import React, { useEffect, useState } from 'react';
import { selectQueried, selectSubregionLayer, zoomToLayer } from './MyMap.js';
import { useMap } from 'react-leaflet/hooks';
// import { tokenMap } from '../data/token_map.js';
// import { partialsMap } from '../data/partials_map.js';
// import DetectDevice from './DeviceDetector.js';

import { Trie } from './Trie.js';
import serializedTrieData from '../data/serializedTrie.json';

export function removeClass(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(
      new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
      ' '
    );
  }
}

export function removeSelected() {
  var items = document.getElementsByClassName('match-item');
  // console.log(items);
  for (var i = 0; i < items.length; i++) {
    removeClass(items[i], 'selected');
  }
}

export function addClass(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    el.className += ' ' + className;
  }
}

var clickOutsideListener = null;

var index = -1;
var matchesList = document.getElementById('matches-list');
var liSelected;
// document.addEventListener('keydown', function (event) {
//     if (matchesList !==  null) {
//         var len = matchesList.getElementsByTagName('li').length - 1;
//         if (event.which === 40) {
//             index++;
//             //down
//             if (liSelected) {
//                 removeClass(liSelected, 'selected');
//                 var next = matchesList.getElementsByTagName('li')[index];
//                 if (typeof next !== undefined && index <= len) {

//                     liSelected = next;
//                 } else {
//                     index = 0;
//                     liSelected = matchesList.getElementsByTagName('li')[0];
//                 }
//                 addClass(liSelected, 'selected');
//                 console.log(index);
//             } else {
//                 index = 0;

//                 liSelected = matchesList.getElementsByTagName('li')[0];
//                 addClass(liSelected, 'selected');
//             }
//         } else if (event.which === 38) {

//             //up
//             if (liSelected) {
//                 removeClass(liSelected, 'selected');
//                 index--;
//                 console.log(index);
//                 next = matchesList.getElementsByTagName('li')[index];
//                 if (typeof next !== undefined && index >= 0) {
//                     liSelected = next;
//                 } else {
//                     index = len;
//                     liSelected = matchesList.getElementsByTagName('li')[len];
//                 }
//                 addClass(liSelected, 'selected');
//             } else {
//                 index = 0;
//                 liSelected = matchesList.getElementsByTagName('li')[len];
//                 addClass(liSelected, 'selected');
//             }
//         }

//     }

// }, false);

const SearchBar = ({
  gridOverlay,
  promptOverlayRef,
  sidebarState,
  setMasterTile,
  setSidebarTitle,
  setSidebar,
  setPopout,
  searchInput,
  setSearchInput,
  setCurrentPrompt,
  setSubregionMode,
  setProjectInfo,
  setTilePreview,
}) => {
  const trie = new Trie();
  trie.deserialize(serializedTrieData);
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (results.length > 0) {
      results.map((result, index) => {
        getSubtiles(
          result.info[1][0],
          result.info[0],
          result.info[1][1],
          searchInput
        );
      });
    }
  }, [results]);

  useEffect(() => {
    getTileUrl(map, gridOverlay, sidebarState, setMasterTile, setSidebarTitle);
  }, []);

  const map = useMap();
  const zoomToLayerClone = (map, feature, { sidebarState }) =>
    zoomToLayer(map, feature, { sidebarState });
  const selectQueriedClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
    queryNumObject,
    setTilePreview,
  }) =>
    selectQueried({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
      queryNumObject,
      setTilePreview,
    });

  var subregionArrayNum = 0;

  const selectSubregionLayerClone = (
    { promptOverlayRef },
    subregionNumObject
  ) => selectSubregionLayer({ promptOverlayRef }, subregionNumObject);

  function minimizeList() {
    const matchesContainer =
      document.getElementsByClassName('matches-container')[0];
    matchesList.style.visibility = 'hidden';
    matchesContainer.style.visibility = 'hidden';
  }

  function showList() {
    const matchesContainer =
      document.getElementsByClassName('matches-container')[0];

    if (matchesList && matchesList.hasChildNodes()) {
      matchesList.style.visibility = 'visible';
      matchesContainer.style.visibility = 'visible';
    }
  }

  function getTileUrl(
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle
  ) {
    var currentUrl = window.location.href;
    var tileUrl = currentUrl.split('/');
    if (tileUrl[tileUrl.length - 1] === '') {
      tileUrl.pop();
    }
    if (tileUrl[tileUrl.length - 2] === 'todem') {
      let input = tileUrl[tileUrl.length - 1];
      let pattern = /^(info($|\.[a-zA-Z0-9_]+$))/;
      if (pattern.test(input)) {
        setProjectInfo(1);
        return;
      } else {
        map.smoothWheelZoom.enable();
        map.touchZoom.enable();
        map.dragging.enable();
      }

      let parts = input.split('.');

      if (parts.length > 2) {
        return false;
      }
      var X = parts[0];
      var Y = parts[1];

      if (Y !== undefined) {
        goToSubtile(X, Y);
        return;
      }

      var queryNumObject = { number: tileUrl[tileUrl.length - 1] };
      var shouldZoom = 1;
      selectQueriedClone({
        map,
        gridOverlay,
        sidebarState,
        setMasterTile,
        setSidebarTitle,
        shouldZoom,
        queryNumObject,
        setTilePreview,
      });
      setSidebar(1);
    }
  }

  function selectSub(parentNum, feature) {
    // selectedSubregion = [layer, feature.properties.img_prompt]
    setCurrentPrompt([
      feature.id,
      feature.properties.img_prompt,
      feature.geometry,
      feature.properties.wiki,
    ]);
    zoomToLayerClone(map, feature, 1);
    setSubregionMode(parentNum);
    //subregionSelected = true;
  }

  // function get

  function getSubtiles(masterTile, matching_phrase, subtile_id, input) {
    if (input.length === 0) {
      return;
    }

    const fetchData = async (masterTile) => {
      const fetcher = async () => {
        // const response = await fetch("http://67.21.32.162/tohm/data/small_geojsons/" + masterTile + ".json")
        const response = await fetch(
          'https://www.latentculture.com/tohm/galactic-react/src/data/small_geojsons/' +
            masterTile +
            '.json'
        );
        // const response = await fetch("https://www.latentculture.com/tohm/data/small_geojsons/" + masterTile + ".json")
        return response.json();
      };
      var promptData = await fetcher();

      if (promptData) {
        var matchesContainer =
          document.getElementsByClassName('matches-container')[0];
        matchesContainer.style.visibility = 'visible';
        matchesContainer.style.display = 'block';
        matchesList = document.getElementById('matches-list');
        matchesList.style.visibility = 'visible';
        matchesList.style.display = 'block';

        var subtiles = promptData.features[0].features;

        for (let i = 0; i < subtiles.length; i++) {
          var id = subtiles[i].features[0].id;
          if (subtile_id === id) {
            var prompt = subtiles[i].features[0].properties.img_prompt;

            var lowerPrompt = prompt.toLowerCase();
            var index;
            var length_of_input = input.length;
            if (!lowerPrompt.includes(input.toLowerCase())) {
              index = 0;
              length_of_input = 0;
            } else {
              index = lowerPrompt.indexOf(input.toLowerCase());
            }

            // at most length is 32 chars long, at min length of prompt
            var length = 32;

            var textBeforePrompt = '';
            var textInPrompt = prompt.substring(index, index + length_of_input);
            var textAfterPrompt = '';

            var nonInput = length - length_of_input;

            if (prompt.length < 32) {
              length = prompt.length;
              if (index !== 0) {
                textBeforePrompt = prompt.substring(0, nonInput / 2);
              }
              var after = index + input.length;
              textAfterPrompt = prompt.substring(after, after + nonInput / 2);
            } else if (index <= nonInput / 2) {
              // if the index is towards the front, we set the start to index of 0;
              textBeforePrompt = prompt.substring(0, index);

              var after = index + input.length;
              var lengthAfter = nonInput + (nonInput - index);
              textAfterPrompt =
                prompt.substring(after, after + lengthAfter) + '...';
            } else {
              var start = index - nonInput / 2;
              textBeforePrompt =
                '...' + prompt.substring(start, start + nonInput / 2);

              var after = index + input.length;
              textAfterPrompt =
                prompt.substring(after, after + nonInput / 2) + '...';
            }

            var newMatch = document.createElement('li');
            newMatch.classList.add('match-item');

            var tileId = document.createElement('span');
            tileId.classList.add('match-id');
            var promptNum = document.createTextNode(
              masterTile.split('-')[1] + '.' + id + ': '
            );
            tileId.appendChild(promptNum);

            var pTextBefore = document.createElement('span');
            var promptTextBefore = document.createTextNode(textBeforePrompt);
            pTextBefore.appendChild(promptTextBefore);

            var pText = document.createElement('span');
            var promptText = document.createTextNode(textInPrompt);
            pText.appendChild(promptText);
            pText.classList.add('keyword');

            var pTextAfter = document.createElement('span');
            var promptTextAfter = document.createTextNode(textAfterPrompt);
            pTextAfter.appendChild(promptTextAfter);

            var allText = document.createElement('div');
            allText.classList.add('match-text');
            allText.appendChild(pTextBefore);
            allText.appendChild(pText);
            allText.appendChild(pTextAfter);

            newMatch.appendChild(tileId);
            newMatch.appendChild(allText);

            newMatch.onclick = function () {
              var queryNumObject = { number: masterTile.split('-')[1] };
              var subregionNumObject = {
                number: i,
                prompt: subtiles[i].features[0].properties.img_prompt,
              };

              setProjectInfo(0);

              var shouldZoom = 0;
              selectQueriedClone({
                map,
                gridOverlay,
                sidebarState,
                setMasterTile,
                setSidebarTitle,
                shouldZoom,
                queryNumObject,
                setTilePreview,
              });
              setSidebar(1);
              selectSub(
                parseInt(queryNumObject.number),
                subtiles[i].features[0]
              );
              minimizeList();
              selectSubregionLayerClone(
                { promptOverlayRef },
                subregionNumObject
              );

              var urlId =
                '/todem/' +
                masterTile.split('-')[1].toString().padStart(4, '0') +
                '.' +
                subtiles[i].features[0].id.toString().padStart(4, '0');
              window.history.pushState('', '', '' + urlId);
              return;
            };

            document.getElementById('matches-list').appendChild(newMatch);
          }
        }
      }
    };

    fetchData(masterTile);
  }

  const handleChange = (e) => {
    e.preventDefault();
    setSearchInput(e.target.value);
    var input = e.target.value;
    var num = null;
    if (isNaN(input) && input.length > 1) {
      var matchesContainer =
        document.getElementsByClassName('matches-container')[0];
      matchesContainer.style.visibility = 'hidden';
      matchesContainer.style.display = 'block';
      matchesList = document.getElementById('matches-list');
      removeSelected();
      index = -1;
      matchesList.innerHTML = '';
      matchesList.style.visibility = 'hidden';

      // in the case of tokens (ie strings) not tile ids
      input = input.toLowerCase();

      // console.log(input)
      if (input.length > 2) {
        // Only search when the input length is at least 2 characters
        const searchResults = trie.autoComplete(input);
        setResults(searchResults);

        if (clickOutsideListener) {
          clickOutsideListener.remove();
        }
        // Set up a click event listener on the document
        var searchContainer =
          document.getElementsByClassName('search-container')[0];
        document.addEventListener('click', function (event) {
          // Check if the click was inside myDiv or not
          var isClickInsideMatches = matchesContainer.contains(event.target);
          var isClickInsideSearch = searchContainer.contains(event.target);

          if (!(isClickInsideMatches || isClickInsideSearch)) {
            matchesContainer.style.visibility = 'hidden';
            matchesList.style.visibility = 'hidden';
          }
        });
      } else {
        setResults([]); // Clear search results when input length is less than 2 characters
      }

      // console.log(result.info)})
      // console.log(results)

      // console.log (results.0)

      // for (let result in results) {
      // console.log(result[0])
      // getSubtiles(result[0][info][1][0], result[info][0], 1);
      // }
      // getSubtiles(allTiles[i], input);
      // check in tokenMap
      // var someTiles = tokenMap.get(input);
      // if (!someTiles) {
      //     someTiles = [];
      // }
      // var extraTiles = partialsMap.get(input);
      // if (!extraTiles) {
      //     extraTiles = [];
      // }

      // var allTiles = someTiles.concat(extraTiles)
      // for (var i = 0; i < allTiles.length; i++) {
      // }
      // return;
    } else if (input.length === 0) {
      var matchesContainer =
        document.getElementsByClassName('matches-container')[0];
      matchesContainer.style.visibility = 'hidden';
      matchesContainer.style.display = 'block';
      matchesList = document.getElementById('matches-list');
      removeSelected();
      index = -1;
      matchesList.innerHTML = '';
      matchesList.style.visibility = 'hidden';
    }
    if (!num) {
      return;
    }
  };

  const searchTile = (e) => {
    var input = e.target.value;
    var num = null;
    if (e.key === 'Enter') {
      num = parseInt(e.target.value);
      if (!num && num !== 0) {
        if (liSelected) {
          console.log(liSelected);
          let parentNum = liSelected.innerText.split('.')[0];
          var queryNumObject = { number: parentNum };
          var shouldZoom = 1;
          selectQueriedClone({
            map,
            gridOverlay,
            sidebarState,
            setMasterTile,
            setSidebarTitle,
            shouldZoom,
            queryNumObject,
            setTilePreview,
          });
          setSidebar(1);
          setProjectInfo(0);
          minimizeList();
          /*
                    const fetchData = async (num) => {
                        const res = await fetch("data/small_geojsons/" + num + ".json")
                        var promptData = await res.json();
                        if(promptData) {
                            var subtiles = promptData.features[0].features;
                            console.log(subtiles[0]);
                            for(var i = 0; i < subtiles.length; i++) {
                            }
                        }
                    }*/
          //fetchData(num);
        }
        return;
      }

      if (!(num !== NaN && 0 <= num && num < 1000)) {
        return;
      }

      var queryNumObject = { number: num };
      var shouldZoom = 1;
      selectQueriedClone({
        map,
        gridOverlay,
        sidebarState,
        setMasterTile,
        setSidebarTitle,
        shouldZoom,
        queryNumObject,
        setTilePreview,
      });
      setProjectInfo(0);
      setSidebar(1);
      setPopout(1);
    }
  };

  function goToSubtile(parentNum, subtile_id) {
    const fetchData = async (tileName) => {
      const fetcher = async () => {
        const response = await fetch(
          'https://www.latentculture.com/tohm/galactic-react/src/data/small_geojsons/' +
            tileName +
            '.json'
        );
        return response.json();
      };
      var promptData = await fetcher();

      if (promptData) {
        var subtiles = promptData.features[0].features;
        for (let i = 0; i < subtiles.length; i++) {
          var id = subtiles[i].features[0].id;
          if (subtile_id === id) {
            var prompt = subtiles[i].features[0].properties.img_prompt;
            var queryNumObject = { number: parentNum };
            var subregionNumObject = {
              number: i,
              prompt: subtiles[i].features[0].properties.img_prompt,
            };
            // console.log("In searchbar: ", subregionNumObject)
            var shouldZoom = 0;
            selectQueriedClone({
              map,
              gridOverlay,
              sidebarState,
              setMasterTile,
              setSidebarTitle,
              shouldZoom,
              queryNumObject,
              setTilePreview,
            });
            setSidebar(1);
            selectSub(parseInt(queryNumObject.number), subtiles[i].features[0]);
            selectSubregionLayerClone({ promptOverlayRef }, subregionNumObject);
            return;
          }
        }
      }
    };

    // Stupid workaround because we designed this badly
    let className;
    if (parentNum <= 9) {
      className = 'classA-';
    } else if (parentNum <= 99) {
      className = 'classB-';
    } else if (parentNum <= 499) {
      className = 'classC-';
    } else {
      className = 'classD-';
    }

    fetchData(className + parentNum);
  }

  return (
    <div style={{ width: '100%' }}>
      <input
        value={searchInput}
        onChange={handleChange}
        onKeyDown={searchTile}
        onClick={showList}
        type="text"
        className="search-input"
        placeholder="search keyword or tile #"
      />
      <div className="matches-container">
        <ul
          id="matches-list"
          onMouseOver={() => {
            map.smoothWheelZoom.disable();
            map.scrollWheelZoom.disable();
          }}
          onMouseOut={() => {
            map.smoothWheelZoom.enable();
          }}
          onTouchStart={() => {
            map.dragging.disable();
          }}
          onTouchEnd={() => {
            map.dragging.enable();
          }}
        ></ul>
      </div>
    </div>
  );
};

export default SearchBar;
